import { useHistory } from "react-router-dom"
import {
	useAuth,
	useGetFavorites,
	useAddFavorite,
	useRemoveFavorite,
	useClearFavorites,
} from "@ncs/ncs-api"
import { useToast } from "@ncs/web-legos"

export const useFavorites = () => {
	const { user } = useAuth()
	const history = useHistory()
	const { makeErrorToast, makeFavoriteToast } = useToast()

	const [favoriteIds = [], , { query: favoritesQuery }] = useGetFavorites()
	const { isFetching: isFetchingFavorites } = favoritesQuery

	const addFavorite = useAddFavorite()
	const removeFavorite = useRemoveFavorite()
	const clearFavorites = useClearFavorites()

	const isFavorite = (partId: string): boolean => favoriteIds.includes(partId)

	const toggleFavorite = async (partId: string): Promise<void> => {
		if (!user) {
			history.push("/auth/login")
			return
		}

		try {
			if (partId && isFavorite(partId)) {
				await removeFavorite(partId)
				makeFavoriteToast(false)
			} else {
				await addFavorite({ id: partId })
				makeFavoriteToast(true)
			}
		} catch {
			makeErrorToast("Could not update favorites. Please try again.")
		}
	}

	const handleClearFavorites = async (): Promise<void> => {
		try {
			await clearFavorites()
		} catch {
			makeErrorToast("Could not clear favorites. Please try again.")
		}
	}

	return { favoriteIds, isFavorite, isFetchingFavorites, toggleFavorite, handleClearFavorites }
}
